"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicCategory = exports.getPublicCategories = exports.putCategoryAccessibility = exports.deleteCategoryPermission = exports.postCategoryPermission = exports.putCategoryAction = exports.delCategory = exports.postCategory = exports.putCategory = exports.getCategory = exports.getCategories = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var categoriesAuthorizedPath = root_1.organizationManagementAuthorized + '/categories/';
var categoriesPublicPath = root_1.organizationManagementPublic + '/categories/';

var getCategories = function getCategories(authentication, queryParameters) {
  return common_1.get(authentication, categoriesAuthorizedPath, queryParameters);
};

exports.getCategories = getCategories;

var getCategory = function getCategory(authentication, id) {
  return common_1.get(authentication, categoriesAuthorizedPath + id);
};

exports.getCategory = getCategory;

var putCategory = function putCategory(authentication, category) {
  return common_1.put(authentication, categoriesAuthorizedPath + category.id, category);
};

exports.putCategory = putCategory;

var postCategory = function postCategory(authentication, category) {
  return common_1.post(authentication, categoriesAuthorizedPath, category);
};

exports.postCategory = postCategory;

var delCategory = function delCategory(authentication, id) {
  return common_1.del(authentication, categoriesAuthorizedPath + id);
};

exports.delCategory = delCategory;

var putCategoryAction = function putCategoryAction(authentication, id, action, data) {
  return common_1.putSub(authentication, categoriesAuthorizedPath, id, action, data);
};

exports.putCategoryAction = putCategoryAction;

var postCategoryPermission = function postCategoryPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, categoriesAuthorizedPath, id, permission);
};

exports.postCategoryPermission = postCategoryPermission;

var deleteCategoryPermission = function deleteCategoryPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, categoriesAuthorizedPath, id, permissionId);
};

exports.deleteCategoryPermission = deleteCategoryPermission;

var putCategoryAccessibility = function putCategoryAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, categoriesAuthorizedPath, id, accessibility);
};

exports.putCategoryAccessibility = putCategoryAccessibility;

var getPublicCategories = function getPublicCategories(authentication, queryParameters) {
  return common_1.get(authentication, categoriesPublicPath, queryParameters);
};

exports.getPublicCategories = getPublicCategories;

var getPublicCategory = function getPublicCategory(authentication, id) {
  return common_1.get(authentication, categoriesPublicPath + id);
};

exports.getPublicCategory = getPublicCategory;